interface LogoProcobProps {
  size?: 'lg' | 'md' | 'sm'
}

export default function LogoProcob({ size = 'lg' }: LogoProcobProps) {
  let width = 176
  let height = 50

  if (size === 'md') {
    width = 132
    height = 37.5
  } else if (size === 'sm') {
    width = 88
    height = 25
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 176 50"
      fill="none"
    >
      <path
        d="M57.3638 14.372H48.3029C47.804 14.372 47.3987 14.7798 47.3987 15.2816V34.7225C47.3987 35.2243 47.804 35.6321 48.3029 35.6321H51.2026C51.7015 35.6321 52.1068 35.2243 52.1068 34.7225V29.6181H57.3617C62.735 29.5575 65.4539 26.2452 65.4539 21.994C65.456 17.8955 62.7683 14.372 57.3638 14.372ZM57.3638 25.277H52.1089V18.8678H57.3638C59.5962 18.8678 60.7457 20.386 60.7457 22.0881C60.7457 23.7882 59.6295 25.277 57.3638 25.277Z"
        fill="white"
      />
      <path
        d="M80.1334 28.2213C84.1805 26.7638 84.9954 24.3026 85.0245 21.5382C85.0245 17.8014 82.3056 14.3699 77.2046 14.3699H68.0834C67.5845 14.3699 67.1792 14.7777 67.1792 15.2796V34.7204C67.1792 35.2223 67.5845 35.63 68.0834 35.63H70.9852C71.4841 35.63 71.8894 35.2223 71.8894 34.7204V28.6479H75.3005L80.4327 35.2829C80.6052 35.5046 80.8672 35.6342 81.1478 35.6342H85.434C85.7894 35.6363 85.912 35.3059 85.6959 34.9964L80.1334 28.2213ZM77.2648 24.6372H71.8894V18.4434H77.2046C79.4079 18.4434 80.3454 20.2062 80.3745 21.6636C80.3745 22.9978 79.4391 24.6372 77.2648 24.6372Z"
        fill="white"
      />
      <path
        d="M98.1616 13.8555C91.3976 13.8555 86.7477 18.0774 86.7477 25.0031C86.7477 31.9288 91.3976 36.1507 98.1616 36.1507C104.926 36.1507 109.573 31.9288 109.573 25.0031C109.575 18.0774 104.926 13.8555 98.1616 13.8555ZM98.1616 31.8682C94.1456 31.8682 91.3665 28.9825 91.3665 25.0031C91.3665 21.1451 94.1456 18.1088 98.1616 18.1088C102.267 18.1088 104.955 21.1158 104.955 25.0031C104.955 28.9532 102.267 31.8682 98.1616 31.8682Z"
        fill="white"
      />
      <path
        d="M128.36 30.4253C128.059 30.0866 127.548 30.0134 127.184 30.2831C125.887 31.2471 124.035 31.8075 122.584 31.8075C117.63 31.8075 115.969 28.2841 115.94 25.1851C115.911 22.0861 117.782 18.3514 122.584 18.3514C124.033 18.3514 125.592 18.7299 126.808 19.6228C127.171 19.8904 127.687 19.811 128.007 19.491L129.662 17.8433C130.032 17.4752 130.032 16.8521 129.635 16.5133C127.597 14.7819 125.176 13.8848 122.584 13.8848C114.822 13.8848 111.259 19.6562 111.29 25.1537C111.322 30.9544 114.521 36.18 122.584 36.18C125.407 36.18 127.961 35.3938 130.027 33.6665C130.414 33.3445 130.431 32.7443 130.096 32.37L128.36 30.4253Z"
        fill="white"
      />
      <path
        d="M142.395 13.8555C135.631 13.8555 130.981 18.0774 130.981 25.0031C130.981 31.9288 135.631 36.1507 142.395 36.1507C149.159 36.1507 153.809 31.9288 153.809 25.0031C153.809 18.0774 149.159 13.8555 142.395 13.8555ZM142.395 31.8682C138.379 31.8682 135.602 28.9825 135.602 25.0031C135.602 21.1451 138.379 18.1088 142.395 18.1088C146.503 18.1088 149.188 21.1158 149.188 25.0031C149.188 28.9532 146.503 31.8682 142.395 31.8682Z"
        fill="white"
      />
      <path
        d="M170.48 24.4866C172.503 23.5456 173.288 21.9041 173.288 20.1434C173.288 16.1933 169.967 14.372 165.951 14.372H156.437C155.938 14.372 155.532 14.7798 155.532 15.2816V34.7225C155.532 35.2243 155.938 35.6321 156.437 35.6321H166.132C170.357 35.6321 173.197 34.0826 173.831 30.649C174.284 28.192 173.166 25.459 170.48 24.4866ZM160.153 18.4726H165.951C167.732 18.4726 168.638 19.3843 168.638 20.6306C168.638 21.8748 167.732 22.636 165.89 22.636H160.153V18.4726ZM165.951 31.5043H160.153V26.584H165.89C167.973 26.584 169.06 27.5877 169.06 29.0744C169.06 30.5612 168.065 31.5043 165.951 31.5043Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.81477 48.9189H2.54538C2.22319 48.9189 1.99454 48.6031 2.09431 48.2937L12.9345 14.7317C12.9989 14.5351 13.1798 14.4013 13.3856 14.4013H18.655C18.9772 14.4013 19.2058 14.7171 19.106 15.0265L8.26584 48.5885C8.20348 48.7872 8.02056 48.9189 7.81477 48.9189Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.6676 48.9189H12.4002C12.078 48.9189 11.8494 48.6031 11.9492 48.2937L27.1296 1.29438C27.194 1.09782 27.3749 0.963989 27.5807 0.963989H32.8501C33.1723 0.963989 33.4009 1.27974 33.3011 1.58922L18.1207 48.5906C18.0563 48.7872 17.8733 48.9189 17.6676 48.9189Z"
        fill="#FF0000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.8295 35.6635H26.5602C26.238 35.6635 26.0093 35.3477 26.1091 35.0382L32.6672 14.7338C32.7317 14.5372 32.9125 14.4034 33.1183 14.4034H38.3877C38.7099 14.4034 38.9385 14.7191 38.8388 15.0286L32.2806 35.3331C32.2162 35.5296 32.0353 35.6635 31.8295 35.6635Z"
        fill="#FF0000"
      />
    </svg>
  )
}
